import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/**
 * Clear cookies before the app loads to prevent RequestHeaderSectionTooLarge (8KB limit).
 * Clears (1) all MSAL-related cookies and (2) any other cookie for this origin that might
 * be large (auth/token/session). Runs before Angular so the first request has minimal cookies.
 */
function clearCookiesBeforeBootstrap(): void {
  try {
    const cookies = document.cookie.split(';');
    const hostname = window.location.hostname;
    const clearName = (name: string): void => {
      if (!name) return;
      document.cookie = `${name}=; Max-Age=0; path=/`;
      document.cookie = `${name}=; Max-Age=0; path=/; domain=${hostname}`;
      if (hostname.indexOf('.') > 0) {
        document.cookie = `${name}=; Max-Age=0; path=/; domain=.${hostname}`;
      }
    };
    cookies.forEach((cookie) => {
      const name = cookie.split('=')[0].trim();
      const lower = name.toLowerCase();
      // Clear MSAL and any auth/token/session cookie that could be large
      if (
        lower.includes('msal') ||
        lower.includes('esctx') ||
        lower.includes('fpc') ||
        lower.includes('x-ms-') ||
        lower.includes('token') ||
        lower.includes('id_token') ||
        lower.includes('access') ||
        lower.includes('auth') ||
        lower.includes('session') ||
        lower.includes('openid') ||
        lower.includes('arraaffinity')
      ) {
        clearName(name);
      }
    });
  } catch (_) {
    // ignore
  }
}

if (environment.production) {
  enableProdMode();
}

clearCookiesBeforeBootstrap();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
